import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useCurrencyContext } from 'src/common/providers/CurrencyProvider';

/**
 * Reload the page's data when the data's currency differs from the selected currency
 * @param currentCurrency The currency that the current data is using
 * @param active Should this reload the data if the currency is different?
 */
const useUpdateDataToMatchCurrency = (currentCurrency?: string, active: boolean = true): void => {
  const { currency } = useCurrencyContext();
  const router = useRouter();

  useEffect(() => {
    if (active && currentCurrency && (currentCurrency !== currency.code)) {
      // Replacing the route informs next to go get the data again
      // with the updated currency as reflected in the preferred_currency cookie.
      router.replace(router.asPath);
    }
  }, [currency.code, currentCurrency, active, router]);
};

export default useUpdateDataToMatchCurrency;
